if (!customElements.get("gaia-product-form")) {
  customElements.define(
    "gaia-product-form",
    class GaiaProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.formId = this.form.getAttribute("id");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        /* custom extended warranty value - START*/
        const extendedWarrantyElement = document.querySelector(
          `.product__extended-warranty[form="${this.formId}"]`,
        );
        if (extendedWarrantyElement && extendedWarrantyElement.value !== "") {
          const quantityInput = document.querySelector(
            `.quantity__input[form="${this.formId}"]`,
          );
          const relatedVariantId = this.form.querySelector("[name=id]").value;
          const cartItemData = {
            items: [
              {
                id: extendedWarrantyElement.value,
                quantity: quantityInput.value,
                properties: {
                  _related_variant_id: relatedVariantId,
                  "Extended Warranty for":
                    extendedWarrantyElement.dataset.title,
                },
              },
            ],
          };

          // Add the extended warranty item to the FormData
          formData.append("items[0][id]", cartItemData.items[0].id);
          formData.append("items[0][quantity]", cartItemData.items[0].quantity);
          formData.append(
            "items[0][properties][_related_variant_id]",
            cartItemData.items[0].properties["_related_variant_id"],
          );
          formData.append(
            "items[0][properties][Extended Warranty for]",
            cartItemData.items[0].properties["Extended Warranty for"],
          );

          const timestamp = new Date().toISOString();
          formData.append("items[0][properties][_timestamp]", timestamp);
          formData.append(
            "items[0][properties][NOTE]",
            "If you have multiple products that require this warranty, please make sure you have added warranties for each individual product.",
          );
          formData.append("properties[_timestamp]", timestamp);
        }

        /* custom extended warranty value - END */

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

class GaiaVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateInventoryAndDelivery();
    this.updateTechSpecs();
    this.updateSku();
    this.updateBundleOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updatePricing();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.setAvailableOptions();
      this.updateSaleBadge();
      this.updateBulkOrder();
      this.updateFinanceDisplay(this.currentVariant.price);
      this.updateTechSpecs();
    }
  }

  setAvailableOptions() {
    // only used in VariantRadios
  }

  updateOptions() {
    // console.log('VariantSelects - updateOptions()');
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(speed = 300) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    if (!mediaGallery) return;

    const media = mediaGallery.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)",
    );
    const variantSlide = getVariantMediaSlide(media, this.currentVariant);

    if (typeof variantSlide === "number" && !Number.isNaN(variantSlide)) {
      mediaGallery.swiper?.slideTo(variantSlide, speed);
    }

    function getVariantMediaSlide(media, variant) {
      for (let i = 0; i < media.length; i++) {
        const variantData = media[i].dataset?.variants;
        if (!variantData) continue;

        let variants;
        try {
          variants = JSON.parse(variantData);
        } catch (error) {
          console.warn("Invalid variant media mapping JSON", {
            slideIndex: i,
            variantData,
            error,
          });
          continue;
        }

        if (!Array.isArray(variants)) continue;

        for (let v of variants) {
          if (String(v) === String(variant.id)) {
            return i;
          }
        }
      }

      return null;
    }

    return variantSlide;
  }

  updatePricing() {
    if (!this.currentVariant) return;

    // console.log(`#shopify-section-${this.dataset.section} .pricing`);
    const pricings = document.querySelectorAll(
      `#shopify-section-${this.dataset.section} .pricing`,
    );
    pricings.forEach((pricing) => {
      if (pricing.dataset.variantId == this.currentVariant.id) {
        pricing.classList.add("active");

        const total_prices = document.querySelectorAll("total-price");
        total_prices.forEach((total_price) => {
          total_price.dataset.basePrice =
            pricing.querySelector(".price-current").dataset.price;
        });
      } else {
        pricing.classList.remove("active");
      }
    });
  }

  updateBundleOptions() {
    if (!this.currentVariant) return;

    const bundles = document.querySelectorAll(".simple-bundles");
    bundles.forEach((bundle) => {
      if (bundle.dataset.variant == this.currentVariant.id) {
        bundle.classList.add("active");
      } else {
        bundle.classList.remove("active");
      }

      const hiddenInputs = bundle.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach((hiddenInput) => {
        if (bundle.dataset.variant == this.currentVariant.id) {
          hiddenInput.removeAttribute("disabled");
        } else {
          hiddenInput.setAttribute("disabled", true);
        }
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl != "true") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, .bundle-sticky-atc--form, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateFinanceDisplay(variantPrice) {
    const financeContainer = document.querySelector(".finance.fs-body-base");
    if (!financeContainer) return;

    // Only show finance if price >= 30000
    if (variantPrice >= 30000) {
      const instalments = Math.round(variantPrice / 3);
      // Format price
      const formattedInstalment = (instalments / 100).toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      financeContainer.querySelector("p span.fs-bold").textContent =
        formattedInstalment;
      financeContainer.style.display = "";
    } else {
      financeContainer.style.display = "none";
    }
  }

  updateTechSpecs() {
    // console.log(
    //   "updateTechSpecs called",
    //   this.currentVariant ? this.currentVariant.id : undefined,
    // );
    const techSpecs = document.querySelectorAll(".variant-tech-spec");
    if (!techSpecs) return;

    techSpecs.forEach((techSpec) => {
      techSpec.classList.remove("active");
      if (techSpec.dataset.variantId == this.currentVariant.id) {
        techSpec.classList.add("active");
      }
    });
  }

  updateSku() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.sku) return;
    const currentSkus = document.querySelectorAll(`.product-sku`);
    if (currentSkus.length > 0) {
      currentSkus.forEach((currentSku) => {
        // Update SKU text
        currentSku.innerHTML = "SKU: " + `${this.currentVariant.sku}`;
        // Toggle 'active' class based on matching SKU
        if (currentSku.dataset.sku === this.currentVariant.sku) {
          currentSku.classList.add("active");
        } else {
          currentSku.classList.remove("active");
        }
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm && typeof productForm.handleErrorMessage === "function") {
      productForm.handleErrorMessage();
    }
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        const saleBadge = document.querySelector(".price__badge-sale");
        if (saleBadge) {
          if (
            this.currentVariant.compare_at_price > this.currentVariant.price
          ) {
            saleBadge.classList.remove("hidden");
          } else {
            saleBadge.classList.add("hidden");
          }
        }

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.sku) return;
    const currentSkus = document.querySelectorAll(`.current__sku`);
    if (currentSkus.length > 0) {
      currentSkus.forEach((currentSku) => {
        currentSku.innerHTML = "SKU: " + `${this.currentVariant.sku}`;
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, .bundle-sticky-atc--form`,
    );
    if (!productForms) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const bisTrigger = productForm.querySelector("#klaviyo-bis-trigger");
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
        if (bisTrigger) bisTrigger.style.display = "flex";
      } else if (!addButton.classList.contains("multi-bundle-disabled")) {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        if (bisTrigger) bisTrigger.style.display = "none";
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const buttons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, .bundle-sticky-atc--form`,
    );
    buttons.forEach((button) => {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    });
  }

  // Update custom inventory display to current variant info
  updateInventoryAndDelivery() {
    if (!this.currentVariant) return;
    const inventories = document.querySelectorAll(".product-inventory");
    if (!inventories) return;

    inventories.forEach((inventory) => {
      inventory.classList.remove("active");
      if (
        parseInt(inventory.dataset.variantId) ===
        parseInt(this.currentVariant.id)
      ) {
        inventory.classList.add("active");
        this.updateBackorderMessaging();
      }
    });

    const deliveries = document.querySelectorAll(".block--delivery__info");
    if (!deliveries) return;

    deliveries.forEach((delivery) => {
      delivery.classList.remove("active");
      if (
        parseInt(delivery.dataset.variantId) ===
        parseInt(this.currentVariant.id)
      ) {
        delivery.classList.add("active");
      }
    });
  }

  // Update custom inventory display to current variant info
  updateBackorderMessaging() {
    let backOrderMsg = document.querySelector(".product-inventory.active");
    if (!backOrderMsg) return;
    let backOrderProperty = document.querySelector("[data-backorder-property]");
    if (
      backOrderMsg &&
      backOrderMsg.classList.contains("product-inventory--backorder")
    ) {
      backOrderProperty.value = backOrderMsg.textContent.trim();
    } else {
      backOrderProperty.value = "";
    }
  }

  // Update any variant promo badges
  updateSaleBadge() {
    const badges = document.querySelectorAll(".price__badge-custom");
    if (!badges) return;

    badges.forEach((badge) => {
      badge.classList.remove("active");
      if (String(badge.dataset.variantId) === String(this.currentVariant.id)) {
        badge.classList.add("active");
      }
    });
  }

  // Update Bulk Order product block with active variant units/pricing tiers
  updateBulkOrder() {
    const quotePricings = document.querySelectorAll(".quote-pricing");
    if (!quotePricings.length) return;
    quotePricings.forEach((el) => {
      if (
        this.currentVariant &&
        el.dataset.variant == this.currentVariant.id.toString()
      ) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("gaia-variant-selects", GaiaVariantSelects);

class GaiaVariantRadios extends GaiaVariantSelects {
  constructor() {
    super();
  }

  setAvailableOptions() {
    this.querySelectorAll('input[type="radio"]').forEach((option) => {
      option.classList.remove("unavailable");
    });

    this.variantData.forEach((variant, v) => {
      let commonOptions = 0;
      let uncommonOption;

      // find unavailable variants
      if (!variant.available) {
        variant.options.forEach((option, o) => {
          // find options in common with current variant
          if (this.currentVariant.options[o] == option) {
            commonOptions++;
          } else {
            // store uncommon option
            uncommonOption = {
              option: o,
              value: option,
            };
          }
        });

        // only continue if all but one option in common
        // find uncommon option radio button and add unavailable class
        if (commonOptions == variant.options.length - 1) {
          this.querySelectorAll("fieldset")
            [
              uncommonOption.option
            ].querySelector(`input[value="${uncommonOption.value}"`)
            .classList.add("unavailable");
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("gaia-variant-radios", GaiaVariantRadios);

class GaiaQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    this.input.addEventListener("change", this.updatePrice.bind(this));
    this.input.addEventListener("keyup", this.updatePrice.bind(this));
    this.input.addEventListener("focusout", this.setMin.bind(this));
  }

  onButtonClick(event = null) {
    if (event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    const inputs = document.querySelectorAll(
      `quantity-input input[data-product="${this.input.getAttribute(
        "data-product",
      )}"],
      quantity-input input[form="${this.input.getAttribute("form")}"]`,
    );
    inputs.forEach((input) => {
      if (
        input !== this.input &&
        input.getAttribute("id") == this.input.getAttribute("id") &&
        !input.classList.contains("bundle-option-quantity")
      ) {
        input.value = this.input.value;
        if (input.closest("product-form").querySelector("total-price")) {
          input
            .closest("product-form")
            .querySelector("total-price").dataset.quantity = this.input.value;
        }
      }
    });
    this.updatePrice();
  }

  updatePrice() {
    const priceContainer =
      this.closest("product-form")?.querySelector("total-price");
    if (priceContainer) priceContainer.dataset.quantity = this.input.value;
  }

  setMin() {
    var isCart = this.closest(".cart-item__quantity-wrapper");
    if (isCart) {
      if (this.input.value >= 1) {
        this.input.value = this.input.value;
      } else {
        this.input.value = 0;
      }
    } else if (this.input.value < 1) {
      this.input.value = 1;
    }
    this.onButtonClick();
  }
}

customElements.define("gaia-quantity-input", GaiaQuantityInput);

// For bundles: If sticky ATC button is clicked, similate a click on main product form submit
// Keeps all the bundle bits & info
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    const stickyBtn = e.target.closest(".product-form__submit.sticky-atc-form");
    if (stickyBtn && !stickyBtn.disabled) {
      // Prevent default sticky ATC action
      e.preventDefault();
      // Find the main product form submit button (not sticky)
      const mainBtn = document.querySelector(
        ".product-form:not(.bundle-sticky-atc--form) .product-form__submit",
      );
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      }
    }
  });
});
